//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HighCharts from 'highcharts';
export default {
  props: ['indexMarket'],
  data() {
    return {
      timeLineArr1: [], // 时间数组，前三个图表的横轴
      seriesData1: [], // 前三个图表的数据轴
      hksz: {
        date: [],
        data: [],
        flowIn: 0,
        balance: 0,
      },
      hksh: {
        date: [],
        data: [],
        flowIn: 0,
        balance: 0,
      },
    };
  },

  mounted() {
    this.flowIn();
    this.getCharts();
  },
  methods: {
    flowIn() {
      if (!this.indexMarket || !this.indexMarket.hkConnectMinLine) {
        return;
      }
      const hkConnectMinLine = this.indexMarket.hkConnectMinLine;
      this.hksz.flowIn = (
        hkConnectMinLine[hkConnectMinLine.length - 1][3] / 100000000
      ).toFixed(2);
      this.hksh.flowIn = (
        hkConnectMinLine[hkConnectMinLine.length - 1][2] / 100000000
      ).toFixed(2);
      this.hksz.balance = (
        this.indexMarket.hkConnectSZBalance / 100000000
      ).toFixed(2);
      this.hksh.balance = (
        this.indexMarket.hkConnectSHBalance / 100000000
      ).toFixed(2);
    },
    getCharts() {
      if (!this.indexMarket || !this.indexMarket.indexDataV2List) {
        return;
      }
      const indexDataV2List = this.indexMarket.indexDataV2List;
      for (let i = 0; i < indexDataV2List.length; i++) {
        this.timeLineArr1 = [];
        this.seriesData1 = [];
        if (!indexDataV2List[i].timeLine) {
          this.timeLineArr1 = [];
          this.seriesData1 = [];
        } else {
          for (let j = 0; j < indexDataV2List[i].timeLine.length; j++) {
            this.timeLineArr1.push(indexDataV2List[i].timeLine[j][0]);
            this.seriesData1.push(indexDataV2List[i].timeLine[j][1] / 1);
          }
        }

        // 前三个图表
        HighCharts.chart('charts' + i, {
          chart: {
            type: 'line',
            width: 69,
            height: 43,
            margin: [0, 0, 0, 0],
            spacing: [0, 0, 0, 0],
          },
          colors: [indexDataV2List[i].change > 0 ? '#ED2C1D' : '#0FA538'],
          title: {
            text: null,
          },
          credits: {
            enabled: false,
          },
          legend: {
            enabled: false,
          },
          tooltip: {
            hideDelay: 100,
            padding: 0,
            formatter() {
              return this.x + '<br />' + this.y;
            },
          },
          plotOptions: {
            series: {
              // fillOpacity:0.1,
              marker: {
                enabled: false,
              },
            },
          },
          xAxis: {
            lineWidth: 0,
            tickWidth: 0,
            labels: {
              enabled: false,
            },
            categories: this.timeLineArr1, // x 轴分类
          },
          yAxis: {
            tickWidth: 0,
            gridLineWidth: 0,
            labels: {
              enabled: false,
            },
            title: {
              text: null, // y 轴标题
            },
          },
          series: [
            {
              lineWidth: 1, // 数据列名
              data: this.seriesData1, // 数据
            },
          ],
        });
      }

      this.hksz.date = [];
      this.hksz.data = [];
      this.hksh.data = [];
      if (!this.indexMarket || !this.indexMarket.hkConnectMinLine) return;
      const hkConnectMinLine = this.indexMarket.hkConnectMinLine;

      for (let i = 0; i < hkConnectMinLine.length; i++) {
        this.hksz.date.push(hkConnectMinLine[i][0]);
        this.hksz.data.push(hkConnectMinLine[i][3] / 1000000); // 数据轴值必须是Number
        this.hksh.data.push(hkConnectMinLine[i][2] / 1000000);
      }
      HighCharts.chart('c1', {
        chart: {
          type: 'line',
          width: 69,
          height: 43,
          margin: [0, 0, 0, 0],
          spacing: [0, 0, 0, 0], // 指定图表的类型，默认是折线图（line）
        },
        title: {
          text: null,
        },
        credits: {
          enabled: false,
        },
        tooltip: {
          hideDelay: 100,
          padding: 0,
          formatter() {
            return this.x + '<br />' + this.y.toFixed(2);
          },
        },
        legend: {
          enabled: false,
        },
        plotOptions: {
          series: {
            fillOpacity: 0.1,
            marker: {
              enabled: false,
            },
          },
        },
        xAxis: {
          lineWidth: 0,
          tickWidth: 0,
          labels: {
            enabled: false,
          },
          categories: this.hksz.date,
        },
        yAxis: {
          tickWidth: 0,
          gridLineWidth: 0,
          labels: {
            enabled: false,
          },
          title: {
            text: null,
          },
        },
        series: [
          {
            lineWidth: 1,
            color: '#ED2C1D',
            data: this.hksz.data,
          },
        ],
      });
      HighCharts.chart('c2', {
        chart: {
          type: 'line',
          width: 69,
          height: 43,
          margin: [0, 0, 0, 0],
          spacing: [0, 0, 0, 0],
        },
        title: {
          text: null,
        },
        credits: {
          enabled: false,
        },
        legend: {
          enabled: false,
        },
        tooltip: {
          hideDelay: 100,
          padding: 0,
          formatter() {
            return this.x + '<br />' + this.y.toFixed(2);
          },
        },
        plotOptions: {
          series: {
            fillOpacity: 0.1,
            marker: {
              enabled: false,
            },
          },
        },
        xAxis: {
          lineWidth: 0,
          tickWidth: 0,
          labels: {
            enabled: false,
          },
          categories: this.hksz.date,
        },
        yAxis: {
          tickWidth: 0,
          gridLineWidth: 0,
          labels: {
            enabled: false,
          },
          title: {
            text: null,
          },
        },
        series: [
          {
            lineWidth: 1,
            color: '#ED2C1D',
            data: this.hksh.data,
          },
        ],
      });
    },
  },
};
